import { fcaFastApi, fcaGateWay } from "../../services/authorizationService";
import * as serviceEndpoints from "../../config/serviceEndPoints";
import { isEnabled } from "../../services/featureFlags";

export const getFloorsBasedOnBuilding = (building_id, params, isGeoHierarchyBasedFloors = false) =>
    isGeoHierarchyBasedFloors
        ? // flat /floors index stays on Rails (not part of the geo writes slice).
          fcaGateWay.get(`${serviceEndpoints.floorEndPoints.getAllFloors}`, { params })
        : (isEnabled("migrate_geo_hierarchy") ? fcaFastApi : fcaGateWay).get(
              `${serviceEndpoints.floorEndPoints.getFloorsBasedOnBuilding}/${building_id}/floors`,
              { params }
          );
export const uploadExcelData = params => fcaFastApi.post(`${serviceEndpoints.floorEndPoints.uploadExcelData}`, params);

export const addFloor = (building_id, params) =>
    (isEnabled("migrate_geo_hierarchy") ? fcaFastApi : fcaGateWay).post(`${serviceEndpoints.floorEndPoints.addFloor}/${building_id}/floors`, params);

export const getFloorById = (building_id, floor_id, isGeoHierarchyBasedFloors = false) =>
    isGeoHierarchyBasedFloors
        ? fcaGateWay.get(`${serviceEndpoints.floorEndPoints.getFloorById}/${floor_id}`)
        : (isEnabled("migrate_geo_hierarchy") ? fcaFastApi : fcaGateWay).get(
              `${serviceEndpoints.floorEndPoints.getFloorById}/${building_id}/floors/${floor_id}`
          );

export const updateFloor = (building_id, floor_id, params, type) =>
    type === "lineEdit"
        ? // line_update stays on Rails (not part of the geo writes slice).
          fcaGateWay.patch(`${serviceEndpoints.floorEndPoints.lineEditUpdate}/${floor_id}/line_update`, params)
        : (isEnabled("migrate_geo_hierarchy") ? fcaFastApi : fcaGateWay).patch(
              `${serviceEndpoints.floorEndPoints.updateFloor}/${building_id}/floors/${floor_id}`,
              params
          );
export const deleteFloor = (building_id, floor_id) =>
    (isEnabled("migrate_geo_hierarchy") ? fcaFastApi : fcaGateWay).delete(
        `${serviceEndpoints.floorEndPoints.deleteFloor}/${building_id}/floors/${floor_id}`
    );
export const getListForCommonFilter = (params, isGeoHierarchyBasedFloors = false) =>
    isGeoHierarchyBasedFloors
        ? fcaGateWay.get(`${serviceEndpoints.floorEndPoints.getListForCommonFilterFloors}/get_list`, {
              params
          })
        : fcaGateWay.get(`${serviceEndpoints.floorEndPoints.getListForCommonFilter}/${params.building_id}/floors/get_list`, {
              params
          });

export const exportFloorsByBuilding = (buildingId, params, isGeoHierarchyBasedFloors = false) =>
    isGeoHierarchyBasedFloors
        ? fcaGateWay.get(`${serviceEndpoints.floorEndPoints.exportFloors}/export_xl`, { method: "GET", responseType: "blob", params })
        : fcaGateWay.get(`${serviceEndpoints.buildingEndPoints.exportBuildings}/${buildingId}/floors/export_xl`, {
              method: "GET",
              responseType: "blob",
              params
          });
export const getAllFloorLogs = (id, params) => {
    return fcaGateWay.get(`${serviceEndpoints.floorEndPoints.getAllFloorLogs}/${id}/logs`, { params });
};
export const restoreFloorLog = id =>
    (isEnabled("migrate_geo_hierarchy") ? fcaFastApi : fcaGateWay).patch(`${serviceEndpoints.floorEndPoints.restoreFloorLog}/${id}/restore`);
export const deleteFloorLog = id => fcaGateWay.delete(`${serviceEndpoints.floorEndPoints.deleteFloorLog}/${id}`);
export const getAllClientUsers = params => fcaGateWay.get(`${serviceEndpoints.floorEndPoints.getAllClientUsers}/client_users_dropdown`, { params });

export const getAllConsultancyUsers = params => fcaGateWay.get(`${serviceEndpoints.floorEndPoints.getAllConsultancyUsers}`, { params });

export const getAllConsultanciesDropdown = () =>
    fcaGateWay.get(`${serviceEndpoints.floorEndPoints.getAllConsultanciesDropdown}/consultancies_dropdown`);

export const getAllClientss = params => fcaGateWay.get(`${serviceEndpoints.floorEndPoints.getAllClients}`, { params });
// export const getAllBuildingss = params =>
//     fcaGateWay.get(serviceEndpoints.floorEndPoints.getAllBuildings, { params });
export const getAllBuildingsDropdown = params =>
    fcaGateWay.get(`${serviceEndpoints.floorEndPoints.getAllBuildingsDropdown}/buildings_dropdown`, { params });

export const getFloorCommonDataByIds = params => fcaFastApi.post(serviceEndpoints.floorEndPoints.getFloorCommonDataByIds, params);

export const updateMultiFloors = params => fcaFastApi.patch(serviceEndpoints.floorEndPoints.updateMultiFloors, params);

export const getAllFloorIds = (building_id, params, isGeoHierarchyBasedFloors = false) =>
    isGeoHierarchyBasedFloors
        ? fcaGateWay.get(`${serviceEndpoints.floorEndPoints.getAllFloorLogs}/group_edit_ids`, { params })
        : fcaGateWay.get(`${serviceEndpoints.floorEndPoints.getAllFloorIds}/${building_id}/floors/group_edit_ids`, { params });
